import { Button, Flex } from "antd";

import StyledContainer from "./styles";

import { ReactComponent as Presentation } from "./image/presentation.svg";
import { ReactComponent as Script } from "./image/script.svg";

const CardNav = ({
  description,
  handleStart,
  handleView,
  isQuizCompleted,
  isStateStarted,
  linkPresentation,
  linkScript,
  loading,
  showLearning,
  title,
  type,
}) => {
  const ButtonAction = () => {
    if (isQuizCompleted)
      return (
        <Button
          block
          onClick={() => handleView(type)}
          shape="round"
          type="text"
        >
          View
        </Button>
      );

    if (isStateStarted)
      return (
        <Button
          block
          onClick={() => handleView(type)}
          shape="round"
          type="text"
        >
          Continue
        </Button>
      );

    return (
      <Button
        block
        disabled={loading}
        onClick={() => handleStart(type)}
        shape="round"
        type="text"
      >
        Get Started
      </Button>
    );
  };

  return (
    <StyledContainer
      className={isQuizCompleted && "state-completed"}
      gap={16}
      justify="space-between"
      vertical
    >
      <Flex gap={8} vertical>
        <h4>{title}</h4>
        <p>{description}</p>
      </Flex>

      <Flex gap={16} vertical>
        {showLearning && (linkPresentation || linkScript) && (
          <Flex
            className="container-presentation"
            justify="space-between"
            style={{ marginTop: 40 }}
          >
            {linkPresentation && (
              <Button
                onClick={() => window.open(linkPresentation, "_blank")}
                type="text"
              >
                <Presentation />
                Presentation
              </Button>
            )}

            {linkScript && (
              <a href={linkScript} download={linkScript} target="_blank">
                <Button type="text">
                  <Script />
                  Script
                </Button>
              </a>
            )}
          </Flex>
        )}

        <ButtonAction />
      </Flex>
    </StyledContainer>
  );
};

export default CardNav;
